import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'tipAccess';

const buildDocId = (senderId, receiverId) => `${senderId}_${receiverId}`;

const getRef = (senderId, receiverId) => doc(db, COLLECTION, buildDocId(senderId, receiverId));

export async function getTipAccessRecord(senderId, receiverId) {
    if (!senderId || !receiverId) return null;
    const ref = getRef(senderId, receiverId);
    const snap = await getDoc(ref);
    return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function hasTipAccess(senderId, receiverId) {
    const record = await getTipAccessRecord(senderId, receiverId);
    return !!(record && record.allowed);
}

export async function grantTipAccess({ senderId, receiverId, tipId = null, source = 'tip', grantedBy = null }) {
    if (!senderId || !receiverId) {
        throw new Error('senderId and receiverId are required to grant tip access');
    }
    const ref = getRef(senderId, receiverId);
    const payload = {
        senderId,
        receiverId,
        allowed: true,
        source,
        tipId: tipId || null,
        grantedBy: grantedBy || null,
        updatedAt: serverTimestamp(),
    };
    await setDoc(ref, payload, { merge: true });
    return payload;
}


